import React from "react";
import Preloader from "../helper/Preloader";
import HeaderOneMain from "../components/UI/HeaderOneMain";
import ProductDetailsMain from "../components/UI/ProductDetailsMain";
// import NewArrivalTwoMain from "../components/UI/NewArrivalTwoMain";
// import ShippingOne from "../components/ShippingOne";
// import NewsletterOne from "../components/NewsletterOne";
import FooterOne from "../components/UI/FooterOneMain";
import BottomFooter from "../components/UI/BottomFooterMain";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";
import Breadcrumb from "../components/UI/BreadcrumbMain";
import ShippingOneMain from "../components/UI/ShippingOneMain";

const ProductDetailsPageMain = () => {
  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* ColorInit */}
      <ColorInit color={false} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#299E60" />

      {/* HeaderOne */}
      <HeaderOneMain />

      {/* Breadcrumb */}
      <Breadcrumb title={"Product Details"} />

      {/* ProductDetailsOne */}
      <ProductDetailsMain />

      {/* NewArrivalTwo */}
      {/* <NewArrivalTwoMain /> */}

      {/* ShippingOne */}
      <ShippingOneMain />

      {/* NewsletterOne */}
      {/* <NewsletterOne /> */}

      {/* FooterTwo */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default ProductDetailsPageMain;
